import { axios2,axios } from '@/lib/axios';
import { ApiResponse, RoleContent } from '@/types';

export type contentManagementDTO = {
  role_name: string;
  id: any;
  permission: any;
};

export const editRoles = (data: contentManagementDTO): Promise<ApiResponse<RoleContent>> => {
  return axios2.post('/admin-api/edit-role', data);
};
